var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitors"},[_c('status-page-monitors',{attrs:{"mode":"update","status-page":_vm.statusPage},on:{"refreshStatusPage":_vm.emitRefreshStatusPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }